// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-circle-loader-container[data-v-249fd4b6] {\n  height: 60px;\n  width: 60px;\n}\n[data-v-249fd4b6] .percentage {\n  font-family: \"Lato\", sans-serif;\n  font-size: 11px;\n  color: #11291B;\n}\n.text-dark-midnight[data-v-249fd4b6] {\n  color: #375C61;\n  font-size: 14px;\n}\n.counter[data-v-249fd4b6] {\n  font-family: \"Lato\", Black;\n  font-size: 20px;\n}\n[data-v-249fd4b6] .percentage {\n  font-size: 0.6em !important;\n}", ""]);
// Exports
module.exports = exports;
